/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Segment_End_LabelInputs */



/**
* | output |
* | --- |
* | "End Timecode" |
*
* @param {Ad_Segment_End_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_segment_end_label = /** @type {((inputs?: Ad_Segment_End_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Segment_End_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code temporel de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale finale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конечный временной код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了タイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समयकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo final")
	return /** @type {LocalizedString} */ ("End Timecode")
});